/*
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: 
 * @LastEditTime: 2022-06-29 09:34:00
 * @FilePath: /Cup2Market/src/directive.js
 * @Description: 
 */
import Vue from "vue";
import store from "@/store";

// 此指令用于确定是否是分销角色
Vue.directive("distributor", {
  inserted(el, binding, vnode, oldVnode) {
    if (store.getters.distributionFlag !== binding.value) {
      el.parentNode.removeChild(el);
    }
  },
});

//为简化使用方式所以现在只支持无参数的调用，带参数还是用loading限制
Vue.directive("gapclick", {
  inserted: function (el, binding) {
    let fn = binding.value;
    let timer;
    el.addEventListener("click", () => {
      if (timer) return;
      fn();
      timer = setTimeout(() => (timer = null), 800);
    });
  },
});
